export default "__VITE_ASSET__Cv$tjCGz__"